<template>
  <div class="container">
    <main-button
      flat
      style="align-self: flex-start; margin-bottom: 1.5rem; padding-left: 0"
      @click="goBack"
    >
      <v-icon class="arrow-back">arrow_back</v-icon>{{ adminText('organizationAll.back_to_subscribers_list_05cccb8b', 'Back to subscribers list') }}
    </main-button>
    <h1 class="subs-title">
      {{ adminText('organizationAll.subscribers_list_23b265ba', 'Subscribers List') }}<span v-if="prepaidCouponName"> - {{ prepaidCouponName }}</span>
    </h1>
    <div v-if="!$apollo.loading">
      <div class="buttons-container">
        <main-button
          depressed
          @click="
            goTo(routes.sportOrganization.sportOrganizationSubscriptionCreate, {
              initialPrepaidCouponId: Number(subscriptionPlanId),
            })
          "
        >
          <span class="add-symbol">+</span>{{ adminText('organizationAll.add_subscriber_ba17b737', 'Add Subscriber') }}
        </main-button>
        <div class="data-manage-buttons-container">
          <main-button
            color="#F5F5F5"
            style="color: #0277bd"
            @click="
              goTo(routes.sportOrganization.sportOrganizationSubscriptionsImport, {
                subscriptionPlanId,
              })
            "
          >
            <img
              src="/assets/import.svg"
              style="width: 1.8125rem; height: 1.8125rem"
              :alt="adminText('organizationAll.import_icon_73519cc7', 'import icon')"
            >{{ adminText('organizationAll.import_b034fe86', 'IMPORT') }}
          </main-button>
          <a
            download
            :href="`${serverURL}/files/sport-organizations/${organizationSlug}/export/subscriptions/xlsx/${token}?subscriptionPlanId=${subscriptionPlanId}`"
          >
            <main-button color="#F5F5F5" style="color: #0277bd">
              <img
                src="/assets/export.svg"
                style="width: 1.8125rem; height: 1.8125rem"
                :alt="adminText('organizationAll.export_icon_1c4dcecc', 'export icon')"
              >{{ adminText('organizationAll.export_c0b9641f', 'EXPORT') }}
            </main-button>
          </a>
        </div>
      </div>
      <v-text-field
        :label="adminText('organizationAll.search_subscribers_96c69857', 'Search Subscribers')"
        append-icon="search"
        box
        style="max-width: 42.75rem; margin: 1rem 0"
        @change="handleSearchChange($event)"
      />
      <div v-if="loading">
        <spinner />
      </div>
      <div
        v-else-if="subscribers.length === 0"
        class="no-attendees-message-container border__left border__right"
      >
        <span class="no-attendees-message">{{ adminText('organizationAll.no_matching_records_found_0c7f0a64', 'No matching records found.') }}</span>
      </div>
      <div v-else>
        <table-list
          :selected.sync="selected"
          :organization-slug="organizationSlug"
          :attendees="subscribers"
          :hide-checkbox="true"
          body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
          :visible-fields="visibleFields"
          :attendee-fields="attendeeFields"
          @click="handleTableRowClick"
          @send-email="handleSendEmailCLick"
        />
        <table-pagination
          :pagination="pagination"
          :total-attendees="totalSubscribersCount"
          @change="handlePagination($event)"
          @changePerPage="handlePagination($event)"
        />
      </div>
      <sport-subscription-details-modal
        v-if="isDetailsModalOpen"
        :prepaid-coupon-user="selectedPrepaidCouponUser"
        :organization-slug="organizationSlug"
        @closeModal="isDetailsModalOpen = false"
        @refetch="fetchSubscribers"
      />
      <simple-snackbar v-bind.sync="snackbar" :message-prop="organizationText(snackbar &amp;&amp; (snackbar.messageProp || snackbar.message))" />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import {
  GET_SPORT_PREPAID_COUPON_USERS_LIST,
  GET_SPORT_PREPAID_COUPON_USER_DETAILS,
} from '@/graphql/prepaidCouponUser.graphql'
import { serverURL } from '@/utils'
import tableList from '../../accreditations/attendee-table/list.vue'
import moment from 'moment'
import SportSubscriptionDetailsModal from '@/components/organizations/subscriptions/SportSubscriptionDetailsModal.vue'
import { getSubscribersExportToken } from '@/http'
import tablePagination from '@/components/accreditations/attendee-table/pagination.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'sport-subscriptions-list',
  components: {
    SimpleSnackbar,
    tablePagination,
    SportSubscriptionDetailsModal,
    tableList,
  },
  props: {
    organizationSlug: {
      type: String,
    },
    subscriptionPlanId: {
      type: String,
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      serverURL,
      subscribers: [],
      pagination,
      token: undefined,
      showDeleteDialog: false,
      openCreateModal: false,
      openUpdateModal: false,
      selected: [],
      organizerId: null,
      attendeeFields: {},
      visibleFields: ['Name', 'Code', 'Subscription Plan', 'Created', 'Expires', ''],
      totalSubscribersCount: 0,
      searchTerm: null,
      isDetailsModalOpen: false,
      selectedPrepaidCouponUser: null,
      allPrepaidCouponUsers: [],
      loading: true,
      snackbar: null,
      prepaidCouponName: null,
    }
  },
  async created() {
    const { data } = await getSubscribersExportToken(this.organizationSlug)
    if (!data) {
      // handle
    }

    this.token = data.token
  },
  async mounted() {
    const { prepaidCouponName } = this.$route.query

    if (prepaidCouponName) {
      this.prepaidCouponName = prepaidCouponName
    }
    await this.fetchSubscribers()
  },
  methods: {
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: descending ? !!descending : false,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })

      await this.fetchSubscribers()
    },
    async fetchSubscribers() {
      this.loading = true
      const {
        data: { getSportPrepaidCouponUsersList },
        errors,
      } = await this.$apollo.query({
        query: GET_SPORT_PREPAID_COUPON_USERS_LIST,
        variables: {
          organizationSlug: this.organizationSlug,
          searchTerm: this.searchTerm,
          pagination: this.pagination,
          prepaidCouponId: this.subscriptionPlanId,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'Oops, Something went wrong!',
          color: 'error',
        }
      } else {
        this.totalSubscribersCount = getSportPrepaidCouponUsersList.count

        this.allPrepaidCouponUsers = getSportPrepaidCouponUsersList.items
        this.subscribers =
          getSportPrepaidCouponUsersList.items.map(e => {
            return {
              id: e.id,
              name: e.name,
              code: e.qrcode,
              'Subscription plan': e.prepaidCoupon.name,
              created: moment(e.createdAt).format('DD.MM.YYYY'),
              expires: moment(e.prepaidCoupon.to).format('DD.MM.YYYY'),
              email: e.email,
              '': 'Send email',
            }
          }) || {}

        if (this.isDetailsModalOpen) {
          this.selectedPrepaidCouponUser = this.allPrepaidCouponUsers.find(
            prepaidCouponUser => prepaidCouponUser.id === this.selectedPrepaidCouponUser.id,
          )
        }
      }
      this.loading = false
    },
    async handleSearchChange(input) {
      this.searchTerm = input
      this.pagination = { ...this.pagination, page: 1 }
      await this.addPaginationToRoute(this.pagination)
    },
    async handleTableRowClick(id) {
      this.loading = true
      const { data, errors } = await this.$apollo.query({
        query: GET_SPORT_PREPAID_COUPON_USER_DETAILS,
        variables: {
          organizationSlug: this.organizationSlug,
          id,
        },
      })
      this.loading = false
      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'Oops, Something went wrong!',
          color: 'error',
        }

        return
      }

      this.selectedPrepaidCouponUser = data.getSportPrepaidCouponUserDetails
      this.isDetailsModalOpen = true
    },
    async handleSendEmailCLick(id) {
      const prepaidCouponUser = this.allPrepaidCouponUsers.find(item => item.id === id)
      let errorMessage
      if (!prepaidCouponUser) {
        errorMessage = 'Something went wrong'
      } else if (
        !(prepaidCouponUser.fields && prepaidCouponUser.fields['Email']) &&
        !prepaidCouponUser.email
      ) {
        errorMessage = 'Please add email to subscriber'
      }

      if (errorMessage) {
        this.snackbar = {
          open: true,
          messageProp: errorMessage,
          color: 'error',
        }

        return
      }

      await this.goTo(this.routes.sportOrganization.sportOrganizationCreateSubscriptionEmail, {
        initialValues: {
          attendees: [prepaidCouponUser],
          prepaidCoupon: prepaidCouponUser.prepaidCoupon,
        },
      })
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalSubscribersCount - currentPerPage * currentPage > 0))
        return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    goBack() {
      this.$router.push(`/sport-organizations/${this.organizationSlug}/subscriptions-list-overview`)
    },
  },
}
</script>

<style scoped>
.page-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.add-symbol {
  font-size: 1.875rem;
  margin-right: 0.8125rem;
  font-weight: 200;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0;
  flex-wrap: wrap;
}
.data-manage-buttons-container {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
</style>
